import TeamsAnalyticsList from '../../components/teams/TeamsAnalyticsList';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction } from '../../modules';

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    listUsersInteraction: _.get(state, 'analytics.listUsersInteraction', []),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 1),
  withState('showUsersFaves', 'setShowUsersFaves', false),
  withHandlers({
    openUserList: props => userList => {
      props.fetchUsersInteraction(userList);
      props.setShowUsersFaves(true);
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {},
  })
);

export default enhance(TeamsAnalyticsList);
